<div class="approval-card-row" *ngIf="interrupt">
  <img class="approval-card-row__avatar" [src]="agentAvatar" alt="Agente" />

  <div
    class="approval-card"
    [class.approval-card--resolved]="readonly && !isCancelled"
    [class.approval-card--cancelled]="readonly && isCancelled"
  >
    <div class="approval-card__header">
    <i class="approval-card__icon" [ngClass]="headerIcon"></i>
    <span class="approval-card__title">{{ headerLabel }}</span>
  </div>

  <div
    class="approval-card__action"
    *ngFor="let action of interrupt.action_requests; trackBy: trackByActionName"
  >
    <div
      class="approval-card__description markdown-content"
      *ngIf="action.payload_markdown || action.description"
      [innerHTML]="contentHtml(action)"
    ></div>
  </div>

  <div class="approval-card__reject" *ngIf="!readonly && showRejectReason">
    <textarea
      class="approval-card__textarea"
      [formControl]="rejectControl"
      placeholder="Motivo do cancelamento (opcional)"
      rows="3"
    ></textarea>
  </div>

  <div class="approval-card__actions" *ngIf="!readonly">
    <ng-container *ngIf="!showRejectReason">
      <button
        type="button"
        class="approval-card__btn approval-card__btn--approve"
        *ngIf="allows(decisionType.APPROVE)"
        [disabled]="submitting"
        (click)="onApprove()"
      >
        Aprovar
      </button>
      <button
        type="button"
        class="approval-card__btn approval-card__btn--reject"
        *ngIf="allows(decisionType.REJECT)"
        [disabled]="submitting"
        (click)="openReject()"
      >
        Cancelar
      </button>
    </ng-container>

    <ng-container *ngIf="showRejectReason">
      <button
        type="button"
        class="approval-card__btn approval-card__btn--reject-confirm"
        [disabled]="submitting"
        (click)="onConfirmReject()"
      >
        Confirmar cancelamento
      </button>
      <button
        type="button"
        class="approval-card__btn approval-card__btn--ghost"
        [disabled]="submitting"
        (click)="cancelReject()"
      >
        Voltar
      </button>
    </ng-container>
    </div>
  </div>
</div>
